export default "__VITE_ASSET__719da8b7__"